import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgArrowDropDown = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	...props,
	children: [
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("style", { children: ".a{fill:none;}" }) }),
		/* @__PURE__ */ _jsx("path", { d: "M7,10l5,5,5-5Z" }),
		/* @__PURE__ */ _jsx("path", {
			className: "a",
			d: "M0,0H24V24H0Z"
		})
	]
});
export default SvgArrowDropDown;
